import { Alert, Button, Card, ColorSchemeSwitch } from '../shared/components';

import styles from './AuthPages.module.css';

/**
 * The waiting screen.
 *
 * The project owner chose that someone awaiting approval enters nothing at all
 * rather than filling a form they might have to redo — so this page has no
 * inputs by design, not by omission (spec FR-008).
 */
export interface PendingApprovalPageProps {
  readonly email: string;
  readonly onSignOut: () => void;
  readonly onRefresh: () => void;
  readonly busy: boolean;
}

export function PendingApprovalPage({
  email,
  onSignOut,
  onRefresh,
  busy,
}: PendingApprovalPageProps) {
  return (
    <div className={styles.page}>
      <div className={styles.schemeSlot}>
        <ColorSchemeSwitch />
      </div>

      <h1 className="visually-hidden">بانتظار الاعتماد</h1>

      <Card title="طلبك قيد المراجعة">
        <div className={styles.waiting}>
          <Alert severity="info">
            استلمنا بياناتك. ستراجعها الموارد البشرية وتربط حسابك بسجلك الوظيفي.
          </Alert>

          <p className={styles.body}>
            سيصلك الوصول للنظام بمجرد الاعتماد. يمكنك التحقق بالضغط على «تحديث».
          </p>

          <p className={styles.note}>الحساب: {email}</p>

          <div className={styles.actions}>
            <Button fullWidth loading={busy} onClick={onRefresh}>
              تحديث
            </Button>
            <Button variant="ghost" fullWidth onClick={onSignOut}>
              تسجيل الخروج
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
